import { bl_aat_engagement_billing_hdr_RowClass } from '../../../dbschema/bl_aat_engagement_billing_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementBillingHdrContainerModel extends BaseContainerModel {
    bl_aat_engagement_billing_hdr: bl_aat_engagement_billing_hdr_RowClass = new bl_aat_engagement_billing_hdr_RowClass();
}